export default {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
};
